import React from 'react';

import CardHOC from './Components/CardHOC';
import Integer from '../../../Types/Components/Integer';

const IntegerTypeCanvas = ({ index, question }) => {
  return <CardHOC index={index} question={question}>
    <Integer question={question} />
  </CardHOC>
}

export default IntegerTypeCanvas;